import { AlertTriangle, Info, TrendingUp, Shield } from "lucide-react";
import { timeOf } from "../lib/format";

const ICONS = {
  TRADE: <TrendingUp size={11} className="text-blue-400" />,
  RISK: <Shield size={11} className="text-red-400" />,
  INFO: <Info size={11} className="text-zinc-400" />,
};

export const AlertsFeed = ({ alerts }) => {
  if (!alerts?.length)
    return <div className="flex-1 flex items-center justify-center text-zinc-600 text-[11px]">No alerts</div>;
  return (
    <div className="flex-1 min-h-0 overflow-auto thin-scroll">
      {alerts.map((a) => (
        <div key={a.id} className="flex items-start gap-2 px-2.5 py-1 border-b border-zinc-800/50">
          <span className="mt-0.5 shrink-0">{ICONS[a.level] || <AlertTriangle size={11} className="text-amber-400" />}</span>
          <span className="text-[10.5px] text-zinc-300 leading-tight flex-1 font-mono">{a.msg}</span>
          <span className="text-[9px] text-zinc-600 font-mono shrink-0">{timeOf(a.ts)}</span>
        </div>
      ))}
    </div>
  );
};
